// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".zUHUsZb5cdfubIgollB1 {\n    padding: var(--spacers-dp4) 0;\n}\n", "",{"version":3,"sources":["webpack://./src/components/Header/DropdownMenu/DropdownMenu.module.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;AACjC","sourcesContent":[".card {\n    padding: var(--spacers-dp4) 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": "zUHUsZb5cdfubIgollB1"
};
export default ___CSS_LOADER_EXPORT___;
